// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //  apiUrl: 'https://app.kampaigns.com/backend/public/',
    // apiUrl: 'http://54.241.242.55:9000/',
   //apiUrl: 'https://dev.kampaigns.com/backend/public/',


  //  apiUrl: 'http://localhost:8001/api/contacts/con/',
  //  apiUrl: 'http://3.141.123.62:8001/api/contacts/con/',

  // apiUrl: 'http://3.141.123.62/api/contacts/con/'
  // apiUrl: 'https://api.cintram.info/api/contacts/con/'
  apiUrl: 'https://api.cintram.app/api/contacts/con/'
  // https://api.cintram.info

  // apiUrl: 'https://139.59.83.155/tea/backend/public/'
   //apiUrl: 'https://staging.kampaigns.com/backend/public/',
  //  stripe_key: 'pk_test_51IdtetGChmZQfy1w02T2MTXh3H5XpY5COe04RnYeowpcbYiD5PK9yC5X8EkOr3nVMULjDE3UOGi19Gm6xqrzyfhn00BkD6I9qN'

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
